import type { CSSProperties } from 'react';
import { Component } from 'react';
import type { ValidationErrors } from '../../utils/validation';
import { emptyValidationErrors } from '../../utils/validation';
import { InputCheckbox, NullableInputText } from './common';

interface IInputTextCheckboxProps {
    automation?: string;
    disabled?: boolean;
    error?: string;
    expandableTextArea?: boolean;
    hasFormControl?: boolean;
    inputStyle?: CSSProperties;
    labelStyle?: CSSProperties;
    name?: string;
    onChange: (value: string | null, checked?: boolean) => Promise<void> | void;
    onDoValidate: () => Promise<void> | void;
    placeholder?: any;
    text: string | null;
}

interface IInputTextCheckboxState {
    checked: boolean;
    errors: ValidationErrors;
    value: string | null;
}

export class InputTextCheckbox extends Component<IInputTextCheckboxProps, IInputTextCheckboxState> {
    constructor(props: IInputTextCheckboxProps) {
        super(props);

        this.state = {
            checked: props.text !== null,
            errors: emptyValidationErrors,
            value: props.text,
        };
    }

    public async componentDidUpdate(prevProps: IInputTextCheckboxProps) {
        if (this.state.checked && this.props.disabled) {
            await this.setState({ checked: false });
        }
    }

    public render() {
        return (
            <InputCheckbox
                automation={this.props.automation}
                checked={this.state.checked}
                disabled={this.props.disabled}
                error={this.props.error}
                hasFormControl={this.props.hasFormControl}
                labelStyle={this.props.labelStyle}
                onChange={async (value) => await this.handleCheckChange(value)}
                onDoValidate={this.props.onDoValidate}
                text={
                    <NullableInputText
                        automation={this.props.automation}
                        disableClickPropagation
                        disabled={this.props.disabled}
                        expandableTextArea={this.props.expandableTextArea}
                        inputStyle={this.props.inputStyle}
                        name={this.props.name}
                        onChange={async (value) => await this.handleTextChange(value)}
                        onDoValidate={this.props.onDoValidate}
                        placeholder={this.props.placeholder}
                        value={this.state.value}
                    />
                }
            />
        );
    }

    private async handleCheckChange(value: boolean) {
        const text = value ? this.props.text : null;
        await this.setState({ checked: value, value: text });
        this.props.onChange(text, value);
    }

    private async handleTextChange(value: string | null) {
        await this.setState({ checked: value !== null, value: value });

        this.props.onChange(value, this.state.checked);
    }
}
